import { Heart } from "lucide-react";
import { useFavorites } from "@/hooks/use-favorites";

type Props = {
  id: string;
  className?: string;
  size?: number;
  variant?: "overlay" | "plain";
};

export function FavoriteButton({ id, className = "", size = 16, variant = "overlay" }: Props) {
  const { has, toggle } = useFavorites();
  const active = has(id);
  const base =
    variant === "overlay"
      ? "inline-flex items-center justify-center rounded-full bg-background/95 p-2 shadow-sm backdrop-blur transition hover:scale-110"
      : "inline-flex items-center gap-1.5 rounded-full border border-border bg-card px-3 py-2 text-sm font-semibold hover:bg-secondary";
  return (
    <button
      type="button"
      aria-label={active ? "Ta bort från sparade" : "Spara fordon"}
      aria-pressed={active}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(id);
      }}
      className={`${base} ${className}`}
    >
      <Heart
        size={size}
        className={active ? "fill-red-500 text-red-500" : "text-foreground/70"}
        strokeWidth={2}
      />
      {variant === "plain" && <span>{active ? "Sparad" : "Spara"}</span>}
    </button>
  );
}
